<template>
  <md-whiteframe md-tag="section" class="card" md-elevation="3">
    <md-card>
      <md-card-area md-inset>
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">{{ product.name }}</div>
          </md-card-header-text>
        </md-card-header>
        <md-card-media>
          <md-icon class="material-icons image">local_laundry_service</md-icon>
          <!-- TODO possible uploading of the image ? -->
        </md-card-media>
        <md-card-content>
          <div v-if="product.description !== ''" class="prod-dsc">{{ product.description }}</div>
          <translate tag="div" v-else class="prod-dsc-empty"> No description </translate>
        </md-card-content>
      </md-card-area>

      <md-card-actions>
        <md-button @click.native="clickEdit(product)" class="md-icon-button">
          <md-icon>edit</md-icon>
        </md-button>
        <md-button id="delete-product" @click.native="openDialog('dialog')" class="md-icon-button">
          <md-icon>delete</md-icon>
        </md-button>
      </md-card-actions>
    </md-card>

    <md-dialog md-open-from="#delete-product" md-close-to="#delete-product" ref="dialog">
      <md-dialog-title><translate>Are you sure you want to delete product:</translate></md-dialog-title>
      <md-dialog-content>
        <md-layout md-align="center"><span class="md-headline">{{ product.name }}</span></md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button id="close-dialog" class="md-default" @click.native="closeDialog('dialog')"><translate>Cancel</translate></md-button>
        <md-button id="confirm-dialog" class="md-raised md-accent" @click.native="confirmDialog('dialog')"><translate>Delete</translate></md-button>
      </md-dialog-actions>
    </md-dialog>

  </md-whiteframe>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'product-card',
  props: [ 'product' ],
  methods: {
    ...mapMutations([
      'productEdit',
      'productToDelete',
      'productCancelDelete'
    ]),
    openDialog (ref) {
      this.$refs[ref].open()
      this.productToDelete(this.product)
    },
    closeDialog (ref) {
      this.$refs[ref].close()
      this.productCancelDelete()
    },
    confirmDialog (ref) {
      this.$refs[ref].close()
      this.$store.dispatch('deleteProducts')
    },
    clickEdit (product) {
      this.$router.push({ name: 'tab-2-edit', params: { id: product._id } })
      this.productEdit(product._id)
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 300px;
  min-width: 200px; /* TODO */
  display: inline-block;
  vertical-align: top;
  margin-bottom: 12px;
  margin-left: 8px;
  margin-right: 8px;
  text-align: center;
}
.image {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #757575;
}
.prod-dsc {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prod-dsc-empty {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/products/Card.vue